import { render, staticRenderFns } from "./IncentivesDetails.vue?vue&type=template&id=39c54148&scoped=true&"
import script from "./IncentivesDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./IncentivesDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IncentivesDetails.vue?vue&type=style&index=0&id=39c54148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c54148",
  null
  
)

export default component.exports